interface ApplicationChild {
	applicationChildId: number;
	applicationId: number;
	customerId: number;
	name: string;
	ssn: string;
	birthDate: string;
	customerResponsibility: 0 | 1 | 2;
}

// Reflect logic in ChildListSection.tsx
const getAge = (birthday: string): number => {
	const birthDate = new Date(birthday);
	const today = new Date();
	let age = today.getFullYear() - birthDate.getFullYear();
	const monthsDiff = today.getMonth() - birthDate.getMonth();
	if (
		monthsDiff < 0 || // Birth-month is a later month than today
		(monthsDiff === 0 && today.getDate() < birthDate.getDate()) // Birth-month is this month, but birth-date is not "here" yet
	)
		age -= 1;
	return age;
};

export function CalculateChildRecord(
	children: ApplicationChild[] = []
): Record<number, ApplicationChild & { age: number }> {
	return (
		children.reduce(
			(acc: Record<number, ApplicationChild & { age: number }>, curr) => {
				acc[curr.applicationChildId] = {
					age: getAge(curr.birthDate),
					customerResponsibility: curr.customerResponsibility
				} as ApplicationChild & { age: number };
				return acc;
			},
			{} as Record<number, ApplicationChild & { age: number }>
		) || {}
	);
}
